import { Action, createReducer, on } from '@ngrx/store';

import * as routerActions from 'sp-mark/redux/router/router.actions';
import { AuthoritiesType, LocalUnit, MenuSectionItem } from 'sp-ui-lib';

export interface RouterState {
  menuSectionItems: Array<MenuSectionItem>;
  localUnits: Array<LocalUnit>;
  routingLog: Array<{path: string; id: string}>;
}

const AUTHORITIES: {[key: string]: AuthoritiesType} = {
  PLATFORM_ADMINISTRATOR: 'MARKET - AMMINISTRATORE DI PIATTAFORMA',
  SELL_AREA: 'MARKET - AREA VENDITA',
  LOCAL_UNITY_DIRECTION: 'MARKET - DIREZIONE UNITA LOCALE',
  SYSTEM_ADMINISTRATION: 'MARKET - AMMINISTRATORE DI SISTEMA'
};

const initialState: RouterState = {
  menuSectionItems: [
    {
      id: 'default_menu',
      label: 'SHARED.MENU.DEFAULT_MENU.TITLE',
      isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.SELL_AREA, AUTHORITIES.LOCAL_UNITY_DIRECTION],
      menuItems: [
        {
          id: 'dashboard',
          icon: 'home',
          label: 'SHARED.MENU.DEFAULT_MENU.DASHBOARD',
          path: '/dashboard',
          flagActive: true,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.SELL_AREA, AUTHORITIES.LOCAL_UNITY_DIRECTION]
        },
        {
          id: 'sell',
          icon: 'shopping_basket',
          label: 'SHARED.MENU.DEFAULT_MENU.SELL',
          path: '/sell',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.SELL_AREA, AUTHORITIES.LOCAL_UNITY_DIRECTION]
        },
        {
          id: 'notifications',
          icon: 'notifications',
          label: 'SHARED.MENU.DEFAULT_MENU.NOTIFICATIONS',
          path: '/notifications',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.SELL_AREA, AUTHORITIES.LOCAL_UNITY_DIRECTION]
        }
      ]
    },
    {
      id: 'my_sells_menu',
      label: 'SHARED.MENU.MY_SELLS_MENU.TITLE',
      isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.SELL_AREA, AUTHORITIES.LOCAL_UNITY_DIRECTION],
      menuItems: [
        {
          id: 'customers',
          icon: 'supervisor_account',
          label: 'SHARED.MENU.MY_SELLS_MENU.CUSTOMERS',
          path: '/customers',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.SELL_AREA, AUTHORITIES.LOCAL_UNITY_DIRECTION]
        },
        {
          id: 'receipts',
          icon: 'account_balance_wallet',
          label: 'SHARED.MENU.MY_SELLS_MENU.RECEIPTS',
          path: '/receipts',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.SELL_AREA, AUTHORITIES.LOCAL_UNITY_DIRECTION]
        },
        {
          id: 'self_purchases',
          icon: 'production_quantity_limits',
          label: 'SHARED.MENU.MY_SELLS_MENU.SELF_PURCHASES',
          path: '/self-purchases',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.SELL_AREA, AUTHORITIES.LOCAL_UNITY_DIRECTION]
        }
      ]
    },
    {
      id: 'my_structure_menu',
      label: 'SHARED.MENU.MY_STRUCTURE_MENU.TITLE',
      isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.LOCAL_UNITY_DIRECTION],
      menuItems: [
        {
          id: 'registry',
          icon: 'assignment',
          label: 'SHARED.MENU.MY_STRUCTURE_MENU.REGISTRY',
          path: '/registry',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR]
        },
        {
          id: 'local_units',
          icon: 'store',
          label: 'SHARED.MENU.MY_STRUCTURE_MENU.LOCAL_UNITS',
          path: '/local-units',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.LOCAL_UNITY_DIRECTION]
        },
          {
          id: 'products_catalog',
          icon: 'wysiwyg',
          label: 'SHARED.MENU.MY_SELLS_MENU.PRODUCTS_CATALOG',
          path: '/products-catalog',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.LOCAL_UNITY_DIRECTION]
        },
        {
          id: 'users',
          icon: 'assignment_ind',
          label: 'SHARED.MENU.MY_STRUCTURE_MENU.USERS',
          path: '/users',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.LOCAL_UNITY_DIRECTION]
        },
        {
          id: 'statistics',
          icon: 'bar_chart',
          label: 'SHARED.MENU.MY_STRUCTURE_MENU.STATISTICS',
          path: '/statistics',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR]
        },
        {
          id: 'integration',
          icon: 'library_books',
          label: 'SHARED.MENU.MY_STRUCTURE_MENU.INTEGRATION',
          path: '/integration',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR]
        }
      ]
    },
    {
      id: 'smallpay_menu',
      label: 'SHARED.MENU.SMALLPAY_MENU.TITLE',
      isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.LOCAL_UNITY_DIRECTION],
      menuItems: [
        {
          id: 'payments',
          icon: 'credit_card',
          label: 'SHARED.MENU.SMALLPAY_MENU.PAYMENTS',
          path: '/payments',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR]
        },
        {
          id: 'services',
          icon: 'library_books',
          label: 'SHARED.MENU.SMALLPAY_MENU.SERVICES',
          path: '/services',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR]
        },
        {
          id: 'request_support',
          icon: 'help_outline',
          label: 'SHARED.MENU.SMALLPAY_MENU.REQUEST_SUPPORT',
          path: '/request-support',
          flagActive: false,
          isVisibleTo: [AUTHORITIES.PLATFORM_ADMINISTRATOR, AUTHORITIES.LOCAL_UNITY_DIRECTION]
        }
      ]
    },
    {
      id: 'manager',
      label: 'SHARED.MENU.MANAGE_USER.TITLE',
      isVisibleTo: [
        AUTHORITIES.PLATFORM_ADMINISTRATOR,
        AUTHORITIES.SELL_AREA,
        AUTHORITIES.LOCAL_UNITY_DIRECTION,
        AUTHORITIES.SYSTEM_ADMINISTRATION
      ],
      menuItems: [
        {
          id: 'manage_user',
          icon: 'contacts',
          label: 'SHARED.MENU.MANAGE_USER.MANAGE_USER',
          path: '/manage-user',
          flagActive: false,
          isVisibleTo: [
            AUTHORITIES.PLATFORM_ADMINISTRATOR,
            AUTHORITIES.SELL_AREA,
            AUTHORITIES.LOCAL_UNITY_DIRECTION,
            AUTHORITIES.SYSTEM_ADMINISTRATION
          ]
        }
      ]
    }
  ],
  localUnits: [],
  routingLog: []
};

const routerReducer = createReducer(
  initialState,
  on(routerActions.activateMenuItem, (state, props) => {
    const newMenuSectionItems = state.menuSectionItems.slice().map(value => ({
      ...value,
      menuItems: value.menuItems.map(item => ({...item, flagActive: item.id === props.menuItemId}))
    }));

    return {
      ...state,
      menuSectionItems: newMenuSectionItems
    };
  }),
  on(routerActions.storeItemToNavigationLog, (state, props) => {
    const newLog = [...state.routingLog];
    if (newLog.length === 10) {
      newLog.shift();
    }

    newLog.push(props.routingObject);

    return {
      ...state,
      routingLog: [...newLog]
    };
  })
);

export function reducer(state: RouterState | undefined, action: Action) {
  return routerReducer(state, action);
}
